import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const GettingStartedMenu00Table: GenericTableSchemaInterface = {
  id: "getting-started-menu-00",
  name: "Getting Started Menu 00",
  description: "This table contains data regarding how people engage with the getting started menus.",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Operator Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Facility ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "Potential: Find Storage Near Me/Show All Spaces"
    },
    c04: {
      name: "Potential: Features & Amenities"
    },
    c05: {
      name: "Potential: Size Options"
    },
    c06: {
      name: "Potential: Our Pricing"
    },
    c07: {
      name: "Potential: I'm an existing customer"
    },
    c08: {
      name: "Potential 2: Start"
    },
    c09: {
      name: "Potential 2: Find Storage Near Me"
    },
    c10: {
      name: "Potential 2: Payment Options"
    },
    c11: {
      name: "Potential 2: Leases"
    },
    c12: {
      name: "Potential 2: Discounts"
    },
    c13: {
      name: "Potential 2: Chat with an Agent"
    },
    c14: {
      name: "Potential 2: Contact CS"
    },
    c15: {
      name: "Existing: Make Payment"
    },
    c16: {
      name: "Existing: Manage My Account"
    },
    c17: {
      name: "Existing: Get Store Hours"
    },
    c18: {
      name: "Existing: Get Gate Code"
    },
    c19: {
      name: "Existing 2: Start"
    },
    c20: {
      name: "Existing 2: Make Payment"
    },
    c21: {
      name: "Existing 2: Provide Referral"
    },
    c22: {
      name: "Existing 2: Give Feedback"
    },
    c23: {
      name: "Existing 2: Chat with an Agent"
    },
    c24: {
      name: "Existing 2: Contact CS"
    },
    c25: {
      name: "Potential: Start"
    },
    c26: {
      name: "Existing: Start"
    },
    c27: {
      name: "Existing: Get Account Balance"
    },
    c28: {
      name: "RVBoat: Start"
    },
    c29: {
      name: "RVBoat: I'm an existing customer"
    },
    c30: {
      name: "RVBoat: Personal Items Storage"
    },
    c31: {
      name: "RVBoat: Vehicle Storage"
    },
    c32: {
      name: "RVBoat: Commercial Storage"
    },
    c33: {
      name: "RVBoat: I need help with something else"
    }
  }
};
